import Route from "@ember/routing/route";
import { service } from "@ember/service";
import type Patient from "parog-web/models/patient";
import type FetcherService from "parog-web/services/fetcher";
import type SemeiaSessionService from "parog-web/services/session";
import { setItemInLocalStorage } from "parog-web/utils/use-local-storage";

export const patientDashboardLastRouteKey = "last-patient-dashboard-route";

export default class BioResultsSummaryRoute extends Route {
  @service declare fetcher: FetcherService;
  @service declare session: SemeiaSessionService;

  override activate() {
    // do nothing if the current user is a patient
    if (this.session.patient) return;

    // if the current user is a medic, set the last dashboard route visited in local storage
    setItemInLocalStorage(
      patientDashboardLastRouteKey,
      "medics-web.protected.patients.patient.dashboard.bio-results.summary"
    );
  }

  override async model() {
    const patient = this.modelFor(
      this.session.patient
        ? "patient-web.protected"
        : "medics-web.protected.patients.patient"
    ) as Patient;

    await Promise.all([
      this.fetcher.loadRecords("bio-exam-results-received-journal-event", {
        filter: { patient_id: patient.id },
        include: [
          "creator",
          "file-attachments-without-zip",
          "apicrypt-message-received-journal-events",
          "bio-exam-results"
        ].join(",")
      }),
      this.fetcher.loadRecords("loinc", {
        filter: { patient_id: patient.id }
      }),
      this.fetcher.loadRecords(
        "bio-exam-expected-dosage-changed-journal-event",
        {
          filter: { patient_id: patient.id }
        }
      )
    ]);

    return patient;
  }
}
